import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {CalendarWidgetComponent} from "./calendar-widget.component";
import {GLMMaterialDesignModule} from "../material-design/material-design.module";

@NgModule({
    imports: [
        CommonModule,
        GLMMaterialDesignModule
    ],
    exports: [CalendarWidgetComponent],
    declarations: [
        CalendarWidgetComponent
    ],
    providers: [],
})
export class CalendarWidgetModule {
}
